export default "__VITE_ASSET__KhdFfteA__"